<template>
  <div class="redemption-code-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-select v-model="params.activityId" size="small" placeholder="请选择活动" filterable clearable>
        <el-option v-for="item in actIDs" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-select v-model="params.type" size="small" placeholder="请选择奖品类型" filterable clearable>
        <el-option v-for="item in priceType" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-select v-model="params.status" size="small" clearable placeholder="请选择是否激活">
        <el-option v-for="item in enables" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="redemptionPrizeList('status')">搜索</el-button>
      <el-button type="primary" size="small" @click="prizeAction('add')">+新增活动奖品</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" max-height="600">
      <!-- <el-table-column prop="id" label="ID" align="center" min-width="220" fixed show-overflow-tooltip>
        <template slot-scope="scope">
          <span> {{scope.row.id  || '未知'}}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="image" min-width="160" label="奖品图片" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'80px'"
            :src="imgUrl + scope.row.image"
            v-if="scope.row.image">
          </img-load>
          <div v-else>暂无图片</div>
        </template>
      </el-table-column>
      <el-table-column prop="activityId" min-width="160" label="活动" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span> {{ formatterAct(scope.row.activityId)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="奖品名称" align="center" min-width="200">
        <template slot-scope="scope">
          <span> {{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="奖品描述" align="center" min-width="200" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span> {{scope.row.desc || "-"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="奖品类型" align="center" min-width="200">
        <template slot-scope="scope">
          <span> {{formatterPriceType(scope.row.type)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="level" label="奖品等级" align="center" min-width="200">
        <template slot-scope="scope">
          <span> {{formatterLevel(scope.row.level)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="奖品价值" show-overflow-tooltip align="center" min-width="200">
        <template slot-scope="scope">
          <span> {{scope.row.price  || "未知"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="count" label="奖品数量" show-overflow-tooltip align="center" min-width="200">
        <template slot-scope="scope">
          <span> {{scope.row.count  || 0}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="value" label="折扣率/活跃值" show-overflow-tooltip align="center" min-width="200">
      </el-table-column>
      <el-table-column prop="status" label="是否激活" align="center" min-width="120" fixed="right">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status">已激活</el-tag>
          <el-tag type="error" v-else>未激活</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="weights" label="中奖权重" align="center" min-width="200">
        <template slot-scope="scope">
          <span> {{scope.row.weights}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="validityTime" label="奖品有效期(天)" align="center" min-width="200">
        <template slot-scope="scope">
          <span> {{scope.row.validityTime}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="奖品排序" align="center" min-width="200"></el-table-column>
      <el-table-column prop="vipCardId" min-width="160" label="会员卡" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span> {{ formatterVip(scope.row.vipCardId)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="220">
        <template slot-scope="scope">
          <span> {{scope.row.createTimt  | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center" min-width="220">
        <template slot-scope="scope">
          <span> {{scope.row.updateTime  | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="operating" label="操作" align="center" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="prizeAction('edit',scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[5,10,15,20]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" background @size-change="changeSize" :total="total" v-if="total > 10" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑tag弹窗-->
    <prize-action ref="prizeAction" :actIDs="actIDs" :vipCardIds="vipCardIds" @handlerCodeList="handlerCodeList"></prize-action>
  </div>
</template>
<script>
import prizeAction from "./components/prizeAction";
import { paramsFilter } from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
import API from "@/api";
import { priceTypes } from "../../../config";
export default {
  components: {
    prizeAction,
  },
  data() {
    return {
      tableData: [],
      loading: false,
      total: "",
      // 奖品列表参数
      params: {
        activityId: "",
        type: "",
        status: "",
        pageNumber: 1,
        pageSize: 10,
      },
      imgUrl: baseConfig.imgUrl,
      actIDs: [],
      vipCardIds: [],
      enables: [
        { label: "未激活", value: false },
        { label: "激活", value: true },
      ],
      levels: [
        { label: "初级", value: 1 },
        { label: "中级", value: 2 },
        { label: "高级", value: 3 },
      ],
      priceType: priceTypes,
    };
  },
  filters: {
    // 是否激活
    isActive(val) {
      switch (val) {
        case false:
          return "未激活";
        case true:
          return "激活";
        default:
          return "未知";
      }
    },
  },
  created() {
    this.redemptionPrizeList();
    this.getActiveityId();
    this.getVipcardId();
  },
  methods: {
    // 获取活动ID
    getActiveityId() {
      API.getActiveityId(this.params).then((res) => {
        if (res.code === 200 && res.data) {
          this.actIDs = res.data;
          return;
        }
        this.$message.error("获取活动失败");
      });
    },
    // 获取VIP ID
    getVipcardId() {
      API.getVipcardId(this.params).then((res) => {
        if (res.code === 200 && res.data) {
          this.vipCardIds = res.data;
          return;
        }
        this.$message.error("获取会员卡失败");
      });
    },
    // 请求兑换码列表
    redemptionPrizeList() {
      this.loading = true;
      let formData = paramsFilter(this.params);
      API.getWebPrice(formData)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.count;
          } else {
            this.tableData = [];
            this.total = 0;
            this.$message.error(res.tip || "获取数据失败");
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    formatterLevel(level) {
      return this.levels.filter((item) => item.value == level).length > 0
        ? this.levels.filter((item) => item.value == level)[0].label
        : "未知";
    },
    formatterPriceType(type) {
      return this.priceType.filter((item) => item.value == type).length > 0
        ? this.priceType.filter((item) => item.value == type)[0].label
        : "未知";
    },
    formatterAct(id) {
      return this.actIDs.filter((item) => item.value == id).length > 0
        ? this.actIDs.filter((item) => item.value == id)[0].label
        : "未知";
    },
    formatterVip(id) {
      return this.vipCardIds.filter((item) => item.value == id).length > 0
        ? this.vipCardIds.filter((item) => item.value == id)[0].label
        : "未知";
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.redemptionPrizeList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.redemptionPrizeList();
    },
    // 编辑活动成功回掉
    handlerCodeList() {
      this.redemptionPrizeList();
    },
    // 新增、删除tags
    prizeAction(type, data) {
      this.$refs.prizeAction.open(type, data);
    },
  },
};
</script>
<style scoped>

</style>
